import { format } from 'date-fns';
import {
  getMarketInsightsQueryKey,
  useLatestArticles,
} from '@/hooks/useLatestArticles';
import ArticleFeedItem from './ArticleFeedItem';
import { ArticleSummary } from './ArticleSummary';
import { Bones } from '@simplywallst/ui-core';

const Skeleton = () => (
  <>
    <div className="grid py-0">
      <Bones maxWidth="100%" minHeight="210px" />
    </div>
    <div className="grid py-1">
      <Bones maxWidth="100%" minHeight="108px" />
    </div>
    <div className="grid py-0">
      <Bones maxWidth="100%" minHeight="100px" />
    </div>
  </>
);

// const highlight = {
//   slug: 'market-insights-1',
//   title: 'Market Insights 1',
//   excerpt: 'Market Insights 1',
//   coverURL: 'https://placehold.co/250x150',
//   created: '2021-01-01',
//   author: {
//     name: 'John Doe',
//     photoURL: 'https://placehold.co/150',
//     slug: 'john-doe',
//   },
// };

// const secondaryArticle = {
//   slug: 'market-insights-2',
//   title: 'Market Insights 2',
//   coverURL: 'https://placehold.co/250x150',
// };

// const isFetching = false;

export const MarketInsights = () => {
  const { data, isFetching } = useLatestArticles(getMarketInsightsQueryKey());
  const [highlight = null, secondaryArticle = null] = data?.articles ?? [];

  if (!highlight) return;

  return (
    <div className="@container">
      <div className="grid">
        {isFetching ? (
          <Skeleton />
        ) : (
          <div className="grid gap-2">
            <ArticleSummary
              slug={highlight.slug}
              title={highlight.title}
              excerpt={highlight.excerpt}
              imageUrl={highlight.coverURL}
              publishedDate={format(new Date(highlight.created), 'MMMM yyyy')}
              author={highlight.author?.name}
              authorAvatarUrl={highlight.author?.photoURL}
              authorSlug={highlight.author?.slug}
            />
            {secondaryArticle && (
              <ArticleFeedItem
                title={secondaryArticle.title}
                imageUrl={secondaryArticle.coverURL}
                slug={secondaryArticle.slug}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
